import { components } from "react-select";

import SelectWithDetailsInput from "../SelectWithDetailsInput";

const CustomOption = (props) => {
  const setOptionTitle = (value) => {
    switch (value) {
      case "stop":
        return "Stop the flow if an error occurs.";
      case "continue":
        return "Continue to the next node if an error occurs.";
    }
  };
  return (
    <components.Option {...props}>
      <div style={{ fontSize: 14, fontWeight: "bold" }}>{props.data.label}</div>
      <div style={{ fontSize: 12 }}>{setOptionTitle(props.data.value)}</div>
    </components.Option>
  );
};

const ErrorHandlingDropdownListItem = ({ action, fieldValue, allowEditWorkflow }) => {
  const options = action.options.map((entry) => {
    if (typeof entry === "object") {
      return {
        value: entry.value,
        label: entry.text,
        isDisabled: entry.disabled
      };
    }
    return {
      value: entry,
      label: entry
    };
  });

  return (
    <SelectWithDetailsInput
      action={action}
      fieldValue={fieldValue}
      allowEditWorkflow={allowEditWorkflow}
      options={options}
      CustomOption={CustomOption}
    />
  );
};

export default ErrorHandlingDropdownListItem;
